import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import AllRoutes from "../kids/kids-list/AllRoutes";
import { PrivateRoute, AuthRoute } from "../../components/";

export class route extends Component {
  render() {
    return (
      <div>
        <PrivateRoute path="/" component={AllRoutes} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(route);
